<template>
	<div class="d-block">
		<div class="videoWrapper">
			<iframe
				width="100%"
				height="405"
				:src="
					`https://www.youtube.com/embed/${_getYTlink(src)}?autoplay=${
						autoplay ? 1 : 0
					}`
				"
				frameborder="0"
				allowfullscreen
			></iframe>
		</div>
	</div>
</template>

<script>
export default {
	name: "AnalyticsElYoutube",
	props: ["src", "autoplay"],
	methods: {
		_getYTlink(str) {
			if (typeof str === "string") {
				str = JSON.parse(str)
			}
			if (typeof str === "string") {
				str = JSON.parse(str)
			}
			return typeof str === "object" ? str.id : ""
		}
	}
}
</script>

<style lang="scss" scoped>
.videoWrapper {
	position: relative;
	padding-bottom: 56.25%; /* 16:9 */
	padding-top: 25px;
	height: 0;
	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
}
</style>
